import { getCancelTokenSource } from '@hotjar/api-base-client';
import type { OrderProcessResponse, SubscriptionAmendmentRequest } from '../api/order/model';
import { customerOrderApi, previewApi } from '../api';
import type { OrderData, OrderService } from './order-service.types';
import type { PreviewCostsResponse } from '../api/preview-cost-changes/model';
import { removeAllowancesOnBasic } from '../utils/allowance.utils';
import { throwAndLogPreviewError } from './error';

export class SubscriptionAmendmentOrderService
  implements OrderService<SubscriptionAmendmentRequest>
{
  #accountId: number;

  #cancelTokenSource = getCancelTokenSource();

  constructor(accountId: number) {
    this.#accountId = accountId;
  }

  preview(data: OrderData): Promise<PreviewCostsResponse> {
    this.#cancelTokenSource?.cancel();
    this.#cancelTokenSource = getCancelTokenSource();

    if (data.allowancesToAdd.length === 0 && data.allowancesToRemove.length === 0) {
      return Promise.reject(new Error("allowancesToAdd or allowancesToRemove shouldn't be empty"));
    }

    return previewApi
      .subscriptionAmendmentCosts(this.mapDataToRequest(data), this.#cancelTokenSource)
      .catch(throwAndLogPreviewError);
  }

  process(data: OrderData): Promise<OrderProcessResponse> {
    return customerOrderApi.amendOrder(this.mapDataToRequest(data));
  }

  mapDataToRequest({
    allowancesToAdd,
    allowancesToRemove,
  }: OrderData): SubscriptionAmendmentRequest {
    return {
      hotjarAccountId: this.#accountId,
      productsToAdd: removeAllowancesOnBasic(allowancesToAdd),
      productsToRemove: removeAllowancesOnBasic(allowancesToRemove),
    };
  }
}
